"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _APPagination = _interopRequireDefault(require("./APPagination/APPagination.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var APPaginationButton = function APPaginationButton(props) {
  var classes = (0, _APPagination["default"])();
  if (props.label === 'PREV') {
    return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({}, props, {
      className: classes.root,
      startIcon: /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
        size: "6x",
        style: props.disabled ? {
          color: 'rgba(0, 0, 0, 0.26)'
        } : {
          color: '#333333'
        },
        icon: _freeSolidSvgIcons.faCaretLeft
      })
    }), props.label);
  }
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({}, props, {
    className: classes.root,
    endIcon: /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      size: "6x",
      style: props.disabled ? {
        color: 'rgba(0, 0, 0, 0.26)'
      } : {
        color: props.color
      },
      icon: _freeSolidSvgIcons.faCaretRight
    })
  }), props.label);
};
var _default = APPaginationButton;
exports["default"] = _default;